window.addEventListener("load", (e) => {
	setTimeout(() => {
		const sliderContainers = [
			...document.querySelectorAll("[swiper-slider]"),
		];
		if (sliderContainers.length !== 0) {
			sliderContainers.forEach((sliderContainer) => {
				const slider = sliderContainer.querySelector("[data-slider]");
				const sliderType = slider.dataset.type;
				const sliderLeftBtn = sliderContainer.querySelector(
					"[data-swiper-previous]"
				);
				const sliderRightBtn =
					sliderContainer.querySelector("[data-swiper-next]");
				let options = {
					keyboard: true,
					pagination: {
						el: ".slider-pagination",
						bulletClass: "slider-pagination__button",
						bulletActiveClass: "slider-pagination__button--active",
						clickable: true,
					},
					navigation: {
						nextEl: sliderRightBtn,
						prevEl: sliderLeftBtn,
					},
					a11y: true,
					cssMode: true,
					watchOverflow: true,
					watchSlidesProgress: true,
				};

				if (sliderType == "recommendation-slider") {
					options = {
						...options,
						slidesPerView: 1.2,
						speed: 600,
						spaceBetween: 20,
						breakpoints: {
							600: {
								slidesPerView: 3,
								slidesPerGroup: 3,
							}, 
							1200: {
								slidesPerView: 4,
								slidesPerGroup: 4, 
							},
							1400: {
								slidesPerView: 6.5,
								slidesPerGroup: 6,
								spaceBetween: 24,
							},
						},
					};
				} 

				const swiper = new Swiper(slider, options);
				const sliderAnnouncer = sliderContainer.querySelector(
					".swiper-notification"
				);
				setupVisibileSlides();

				// remove role="group" from li slide elements
				const liSlides = [...slider.querySelectorAll('[data-slider-item]')]
				liSlides.forEach(slide => slide.removeAttribute('role'))

				// Announce new slide to screen reader users -- multiple slider per view
				if (sliderType == "recommendation-slider") {

					[sliderLeftBtn, sliderRightBtn].forEach((sliderBtn) => {

						sliderBtn.addEventListener('click', e => {
							const activeSlides = [...slider.querySelectorAll('.swiper-slide-fully-visible')];
							const firstActiveSlide = activeSlides[0];
							const lastActiveSlide = activeSlides[activeSlides.length - 1];
							const activeSlideIndexStart = firstActiveSlide.getAttribute('aria-label').replace(/(^\d+)(.+$)/i, '$1');
							const activeSlideIndexEnd = lastActiveSlide.getAttribute('aria-label').replace(/(^\d+)(.+$)/i, '$1');

							sliderAnnouncer.textContent = `now showing slides ${activeSlideIndexStart} through ${activeSlideIndexEnd}`

							setupVisibileSlides()
						})
					});
				}
				// removes aria-hidden = true and tabindex for slides that are visible (voiceover ada)
				function setupVisibileSlides() {
					const sliderItems = [...slider.querySelectorAll('[data-slider-item]')];
					sliderItems.forEach(sliderItem => {
						if (sliderItem.classList.contains("swiper-slide-visible")) {
							sliderItem.removeAttribute('aria-hidden');
							sliderItem.removeAttribute('tabindex');
							sliderItem.querySelectorAll('a').forEach(anchor => anchor.removeAttribute('tabindex'));
						}
						else {
							sliderItem.setAttribute('aria-hidden', "true");
							sliderItem.setAttribute('tabindex', "-1");
							sliderItem.querySelectorAll('a').forEach(anchor => anchor.setAttribute('tabindex', "-1"));
						}
					})
				}

			});
		}
	}, 3000);
});
